<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "patient-queue"
};
</script>

<style lang="scss" scoped></style>
